import React from "react";
import { Form, Input } from "antd";
import { createPlaywrightForm } from "../createPlaywrightForm";
const { TextArea } = Input;

const ClosingReasonInfoReadOnlyForm = ({ closingReason, closingReasonComment, form }) => {
	const { getFieldDecorator } = form;
  
  return (
    <Form layout="vertical">
      <Form.Item
        label="Motivo"
      >
        {getFieldDecorator("closing_reason", {initialValue: closingReason.description })(
          <Input readOnly={true} />
        )}
      </Form.Item>
      <Form.Item
        label="Comentario"
      >
        {getFieldDecorator("closing_reason_comment", {initialValue: closingReasonComment })(
          <TextArea
            autoSize
            readOnly={true}
          />
        )}
      </Form.Item>
    </Form>
  );
};


const createForm = typeof Form.create === "function" ? Form.create : createPlaywrightForm;
const ClosingReasonInfo = createForm({ name: "closing-reason-no-edit-form" })(ClosingReasonInfoReadOnlyForm);

export default ClosingReasonInfo;
